import React from 'react';
import PropTypes from 'prop-types';
import Footer from './InputFooter';
import Confirm from '../confirm';

const InputFile = ({
  id,
  label,
  fields,
  onChange,
  tempFile,
  onRemove,
  children,
  groupFile,
  showDelete,
  hideConfirm,
  showConfirm,
  onRemoveMult,
  tempMulFiles,
  onChangeGroup,
  onRemoveCallback,
  onRemoveCallbackMult,
  withFooter,
}) => (
  <React.Fragment>
    <div className="input-wrp">
      {!groupFile ?
        <div>
          <div style={{ position: 'relative' }}>
            {label && (<label htmlFor={id}>{label}</label>)}
            <input id={id} type="file" onChange={onChange} className="input-file" />
            {!!children && (
            <div>
              <div>
                {children}
              </div>
            </div>
            )}
          </div>
          {
            withFooter
              ? <Footer
                id={id}
                tempFile={!!tempFile}
                onChange={onChange}
                onRemove={onRemove}
                showConfirm={showConfirm}
                hideConfirm={hideConfirm}
                onRemoveCallback={onRemoveCallback}
                showDelete={showDelete}
              />
              : <div className="center">
                { !!tempFile && showDelete && (
                  <input
                    type="button"
                    id=""
                    value="x"
                    className="btn-rmv1"
                    onClick={onRemove}
                    style={{ display: 'inline-block' }}
                  />) }
              </div>
          }
        </div> :
        <div>
          <div className="attach-file">
            {label && (<label className="pointer" htmlFor={id}>{label}</label>)}
            <input
              id={id}
              type="file"
              multiple
              onChange={onChangeGroup}
              className="input-file group-input file-input"
            />
          </div>
          <div className="files">
            {tempMulFiles.length ? tempMulFiles.map((file, i) => (
              <div key={i}>
                {fields({ file, onRemove: onRemoveMult })}
              </div>
            )) : ''}
          </div>
        </div>
      }
      <Confirm
        show={showConfirm}
        cancelCallback={hideConfirm}
        successCallback={!groupFile ? onRemoveCallback : onRemoveCallbackMult}
      />
    </div>
  </React.Fragment>
);

InputFile.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  showConfirm: PropTypes.bool.isRequired,
  tempFile: PropTypes.object,
  onRemoveCallback: PropTypes.func.isRequired,
  fields: PropTypes.func,
  groupFile: PropTypes.bool,
  showDelete: PropTypes.bool,
  onRemoveMult: PropTypes.func.isRequired,
  tempMulFiles: PropTypes.array.isRequired,
  onChangeGroup: PropTypes.func.isRequired,
  onRemoveCallbackMult: PropTypes.func.isRequired,
};

export default InputFile;



// WEBPACK FOOTER //
// ./src/components/inputFile/InputFile.js